export const isStationOffline = (presence: Presence) => presence === "unavailable" || presence === "sender_offline";
